"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var Localize_1 = require("../../../gen-src/Localize");
var DatabasesBreadcrumbsUpdater_1 = require("../../breadcrumbs/DatabasesBreadcrumbsUpdater");
var TablesBreadcrumbsUpdater_1 = require("../../breadcrumbs/TablesBreadcrumbsUpdater");
var UnrecognizedUrl_1 = require("../../error/components/UnrecognizedUrl");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var VizPortalStyles_1 = require("../../style/VizPortalStyles");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var BrowserTitleUpdater_1 = require("../BrowserTitleUpdater");
var DatabasePlacePage_1 = require("../DatabasePlacePage/DatabasePlacePage");
var TablePlacePage_1 = require("../TablePlacePage/TablePlacePage");
var CatalogBrowserHeader_1 = require("./CatalogBrowserHeader");
var CatalogBrowserPlacePageLayout_1 = require("./CatalogBrowserPlacePageLayout");
var CatalogBrowser = /** @class */ (function (_super) {
    __extends(CatalogBrowser, _super);
    function CatalogBrowser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCatalogRoute = function (urls) {
            return (React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { exact: true, path: urls.catalogDatabasesPath(), render: _this.renderDatabasesPlacePage }),
                React.createElement(react_router_dom_1.Route, { exact: true, path: urls.catalogTablesPath(), render: _this.renderTablesPlacePage }),
                React.createElement(react_router_dom_1.Route, { path: urls.catalogDatabasePath(':databaseId'), render: function (_a) {
                        var match = _a.match;
                        return React.createElement(DatabasePlacePage_1.DatabasePlacePage, { databaseId: match.params.databaseId });
                    } }),
                React.createElement(react_router_dom_1.Route, { path: urls.catalogTablePath(':tableId'), render: function (_a) {
                        var match = _a.match;
                        return React.createElement(TablePlacePage_1.TablePlacePage, { tableId: match.params.tableId });
                    } }),
                React.createElement(react_router_dom_1.Redirect, { exact: true, from: urls.catalogPath(), to: urls.catalogDatabasesPath() }),
                React.createElement(UnrecognizedUrl_1.UnrecognizedUrl, { backToButtonLabel: Localize_1.Messages.BackToCatalog(), backToButtonUrl: urls.catalogPath() })));
        };
        _this.renderDatabasesPlacePage = function (routeProps) {
            return (React.createElement(React.Fragment, null,
                React.createElement(BrowserTitleUpdater_1.BrowserTitleUpdater, { nameFunction: Localize_1.Messages.DatabasesAndFiles, browserTitleUpdateType: BrowserTitleUpdater_1.BrowserTitleUpdateType.TITLE_WITH_PLACE_NAME_FUNCTION }),
                React.createElement(DatabasesBreadcrumbsUpdater_1.DatabasesBreadcrumbsUpdater, null),
                React.createElement(CatalogBrowserPlacePageLayout_1.CatalogBrowserPlacePageLayout, { selectedSubplace: CatalogBrowserHeader_1.CatalogBrowserSubplace.Databases, locationSearch: routeProps.location.search, renderExplorerComponent: _this.props.renderDatabasesExplorer, registerErrorStore: _this.props.registerErrorStore, unregisterErrorStore: _this.props.unregisterErrorStore })));
        };
        _this.renderTablesPlacePage = function (routeProps) {
            return (React.createElement(React.Fragment, null,
                React.createElement(BrowserTitleUpdater_1.BrowserTitleUpdater, { nameFunction: Localize_1.Messages.Tables, browserTitleUpdateType: BrowserTitleUpdater_1.BrowserTitleUpdateType.TITLE_WITH_PLACE_NAME_FUNCTION }),
                React.createElement(TablesBreadcrumbsUpdater_1.TablesBreadcrumbsUpdater, null),
                React.createElement(CatalogBrowserPlacePageLayout_1.CatalogBrowserPlacePageLayout, { selectedSubplace: CatalogBrowserHeader_1.CatalogBrowserSubplace.Tables, locationSearch: routeProps.location.search, renderExplorerComponent: _this.props.renderTablesExplorer, registerErrorStore: _this.props.registerErrorStore, unregisterErrorStore: _this.props.unregisterErrorStore })));
        };
        return _this;
    }
    CatalogBrowser.prototype.render = function () {
        var _this = this;
        return (React.createElement(LayoutComponents_1.VerticalFlexContainer, { fillFlexParent: true, additionalClassNames: [VizPortalStyles_1.vizPortalFontClass, VizPortalStyles_1.minWidthClass] },
            React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
                return React.createElement(react_router_dom_1.Route, { path: urls.catalogPath(), render: function () { return _this.renderCatalogRoute(urls); } });
            })));
    };
    return CatalogBrowser;
}(React.Component));
exports.CatalogBrowser = CatalogBrowser;
//# sourceMappingURL=CatalogBrowser.js.map